// extracted by mini-css-extract-plugin
export default {"second":"allTalentOffers_second__b812O","card":"allTalentOffers_card__8YCNX","cardBody":"allTalentOffers_cardBody__aPmtG"};